import {WindowEvents} from "../../global/kendoWindows";

export default function () {
    WindowEvents.onOpenEvents.PrfCreateWindow = function () {
        let $window = this.element;
        let $continueButton = $window.find('.js-continue-button');
        $continueButton.unbind('click');
        $continueButton.click(function () {
            let type = $('[name=prfType]:checked').val()
            if (type == null) {
                $window.find('.js-type-error').show();
                return;
            }
            window.location = `/Sales/PursuitRequestForm/${type}`;
        })
    }
}